"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable react-hooks/rules-of-hooks */
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importStar(require("react"));
const react_use_1 = require("react-use");
const utils_1 = require("../../utils");
const Item_1 = require("./Item");
const art_1 = require("../../art");
const isPathDetail = (resourceName, pathname) => {
    const regExp = new RegExp(`/${resourceName.replace('/', '')}(/.*)?`, 'g');
    return pathname.match(regExp);
};
exports.OsmosysAppNavBreadcrumb = ({ basePath, pathname, isAdminOnly, resourceLabel, }) => {
    const show = react_1.useMemo(() => {
        return isPathDetail(basePath, pathname);
    }, [basePath, pathname]);
    // TODO: add data-osmosys-comp="OsmosysAppNav" somewhere
    return (react_1.default.createElement(utils_1.OsmosysDiv, { flexRow: true }, show && (react_1.default.createElement(react_1.default.Fragment, null,
        isAdminOnly && (react_1.default.createElement(Item_1.OsmosysAppNavItem, { chevron: true, to: "/admin", tooltip: "Admin" },
            react_1.default.createElement(art_1.OsmosysIcon, { osysIcon: "appAdminsOnly", iconStyle: "solid" }))),
        react_1.default.createElement(Item_1.OsmosysAppNavItem, { chevron: true, to: basePath, tooltip: resourceLabel }, resourceLabel),
        react_1.default.createElement(utils_1.OsmosysDiv, { id: "app-nav-breadcrumb", className: "d-lg-flex d-none", flexRow: true })))));
};
exports.OsmosysAppNavBreadcrumb.Extra = ({ to, label, children, loading }) => {
    const [mounted, toggleMount] = react_use_1.useToggle(false);
    react_1.useEffect(() => {
        const t = setTimeout(() => {
            toggleMount(true);
        }, 2 * 100);
        return () => {
            clearTimeout(t);
        };
    }, [toggleMount]);
    if (!mounted || loading) {
        children = (react_1.default.createElement("div", { className: "flex-full-col-centered mx-2" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSpinnerThird, spin: true })));
    }
    return (react_1.default.createElement(utils_1.Portal, { elementID: "app-nav-breadcrumb" },
        react_1.default.createElement(Item_1.OsmosysAppNavItem, { chevron: true, to: to }, typeof children === 'function'
            ? children() || label
            : children || label)));
};
//# sourceMappingURL=Breadcrumb.js.map